$(function() {

    $.facts = {};

    $.facts.count = 4;

    for (var i = 0; i < $.facts.count; i++) { // for each facts page

        var j = i + 1;
        var id = 'facts-'+ j;
        var section = '#'+ id +'-section';

        $.facts[id] = {};

        // durations

        $.facts[id].duration = '50%';

        $.facts[id].calculatePinDuration = function() {
            var contentHeight = $(section +' .facts').outerHeight();
            $.facts[id].pinDuration = Math.round(contentHeight + ($(window).innerHeight()));
            return $.facts[id].pinDuration;
    	};

        $.facts[id].endDuration = ($(section).next('section').hasClass('profile-section')) ? '50%' : '100%'; // check if profile follows

        // timelines

        $.facts[id].tl = {};

        // in

    	$.facts[id].tl.in = new TimelineMax();

        $.facts[id].tl.in.addLabel("start");
        $.facts[id].tl.in.addLabel("content", 1);

        $.facts[id].tl.in.set(section, { visibility: "visible" }, "start");﻿

        $.facts[id].tl.in.set(section +' .facts-background', { backgroundColor:$.color.black }, "start");
        $.facts[id].tl.in.fromTo(section +' .facts-background', 1, { opacity:0 }, { opacity:1 }, "start");

        $.facts[id].tl.in.add(function(){ $('.fact').removeClass('fact-active'); }, "content");
        $.facts[id].tl.in.fromTo(section +' .facts', 1, { opacity:0 }, { opacity:1 }, "content");

        new ScrollMagic.Scene({ triggerElement: section +' .facts-pin', triggerHook: 'onLeave', duration: $.facts[id].duration })
            .on('start', function () {
                $('.fact').removeClass('fact-active');
                $('.facts').removeClass('facts-active');
            })
            .setTween($.facts[id].tl.in)
        	// .addIndicators({name: 'facts '+ j +' in'})
        	.addTo($.controller);

        new ScrollMagic.Scene({ triggerElement: section +' .facts-pin', triggerHook: 'onLeave', duration: $.facts[id].calculatePinDuration })
            .setPin(section +' .facts-background')
            // .addIndicators({name: 'facts '+ j +' pin'})
            .addTo($.controller);

        $.facts[id].tl.out = new TimelineMax();

        $.facts[id].tl.out.addLabel("start");

        $.facts[id].tl.out.to(section +' .facts-background', 1, { opacity:0, delay:1 }, "start");
        $.facts[id].tl.out.to(section +' .facts', 1, { opacity:0, delay:1 }, "start");

        new ScrollMagic.Scene({ triggerElement: section +' .facts-end', triggerHook: 'onCenter', duration: $.facts[id].endDuration })
            .on('leave', function () {
                $('.fact').removeClass('fact-active');
                $('.facts').removeClass('facts-active');
            })
            .setTween($.facts[id].tl.out)
            // .addIndicators({name: 'facts '+ j +' out'})
            .addTo($.controller);

    } // end for each facts page

});
